import toast from "react-hot-toast";
import api from "../Crypto/axios.js";

export const USER_CART = "USER_CART";
export const ADD_CART_PRODUCTS = "ADD_CART_PRODUCTS";
export const GET_CART_PRODUCTS = "GET_CART_PRODUCTS";

const initialState = {
  userCart: [],
  cartOrders: [],
  cartProducts: [],
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_CART:
      return {
        ...state,
        userCart: action.payload,
      };
    case ADD_CART_PRODUCTS:
      return {
        ...state,
        cartOrders: action.payload,
      };
    case GET_CART_PRODUCTS:
      return {
        ...state,
        cartProducts: action.payload,
      };
    default:
      return state;
  }
};

export default cartReducer;

export const addCartProducts = (data) => ({
  type: ADD_CART_PRODUCTS,
  payload: data,
});

export const addUserCart = (data) => ({
  type: USER_CART,
  payload: data,
});

export const getCartProducts = (data) => ({
  type: GET_CART_PRODUCTS,
  payload: data,
});

export const addCartProduct = (newProduct) => {
  return async (dispatch) => {
    const promise = api
      .post('/nrcb/ecom/add/cart/product', newProduct, { requiresAuth: true })
      .then((response) => {
        if (!response) {
          throw new Error('Failed to add cart');
        }
        dispatch(addCartProducts(response));
        return response;
      })
      .catch((error) => {
        console.error('Error in add new cart:', error);
        // Instead of throwing, just return a rejected promise for toast
        return Promise.reject(new Error(error?.message || 'Failed to add cart'));
      });

    toast.promise(promise, {
      loading: 'Adding New Cart...',
      success: 'Added to Cart',
      error: (error) => error.message || 'Failed to add cart',
    });

    // Don't rethrow; just return the promise so toast can handle it
    return promise;
  };
};


export const editCartProduct = (newProduct) => {
  return async (dispatch) => {
    const promise = api
      .post('/nrcb/ecom/edit/cart/product/', newProduct, { requiresAuth: true })
      .then((response) => {
        dispatch(addUserCart(response));
        return response;
      })
      .catch((error) => {
        console.error('Error in edit cart product:', error);
        throw new Error(
          error?.response?.data?.message || 'Failed to edit cart product'
        );
      });

    toast.promise(promise, {
      loading: 'Updating cart...',
      success: 'Cart updated successfully!',
      error: (error) => error.message || 'Failed to update cart',
    });

    return promise;
  };
};

export const getCartProduct = (user_id) => {
  return async (dispatch) => {
    try {
      const response = await api.get(`/nrcb/ecom/get/cart/product/${user_id}`, {
        requiresAuth: true,
      });
      if (!response) {
        throw new Error('Failed to fetch cart');
      }
      dispatch(getCartProducts(response));
      return response;
    } catch (error) {
      console.error('Cart fetch error:', error);
      throw error;
    }
  };
};




